import { FC, ReactNode } from 'react';

import cx from 'classnames';

import { EColors, TColors, TSizesExtended } from '../../types';

import styles from './Title.module.scss';

type TVariant = 'default' | 'benzin' | 'cormorant';

type TTitleSize = TSizesExtended;

type TTitleProps = {
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'span';
  line?: '100' | '125' | '150' | 'normal';
  children?: ReactNode;
  className?: string;
  color?: TColors;
  isInsertion?: boolean;
  size?: TTitleSize;
  variant?: TVariant;
  wrap?: 'preLine';
};

export const Title: FC<TTitleProps> = ({
  as = 'h4',
  line,
  children,
  className,
  color = EColors.text,
  isInsertion = false,
  size = 'm',
  variant = 'default',
  wrap,
}) => {
  const Tag = isInsertion ? 'span' : as;

  return (
    <Tag
      className={cx(
        styles.title,
        styles[variant],
        size && styles[size],
        color && styles[color],
        line && styles[`line-${line}`],
        wrap && styles[wrap],
        className,
      )}
    >
      {children}
    </Tag>
  );
};
